// extracted by mini-css-extract-plugin
module.exports = {"containerItem":"setting_containerItem__1BEDH","select":"setting_select__1JHfQ","disease":"setting_disease__3VHt5","chuFaType":"setting_chuFaType__2u8rm"};